import {
    StepVariables,
    ToolContext
} from "@omni/types/components/tracking/tracking-info/tools/toolStep.trackingInfo";

type StepKeys = "start" | "submit";

const TOOL_BONUS_CARD_STEPS: Record<StepKeys, StepVariables> = {
    start: {
        stepName: "Vraag je Bonus Kaart aan",
        stepNumber: 1,
        placement: "promoties:bonuskaart",
        result: {},
        option: ""
    },
    submit: {
        stepName: "aanvraag doorgestuurd",
        stepNumber: 2,
        placement: "promoties:bonuskaart:bonuskaart - bedankt voor je aanvraag",
        result: {}, // customerId, store, birthdayoptin
        option: ""
    }
};

const TOOL_BONUS_CARD_CONTEXT: Readonly<ToolContext> = {
    name: "bonuscard",
    type: "form"
};

export { TOOL_BONUS_CARD_CONTEXT, TOOL_BONUS_CARD_STEPS };
